import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { ConvertEstimateToProposalMutation as ConvertEstimateToProposalMutationResult } from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const ConvertEstimateToProposalMutation = graphql(`
  mutation ConvertEstimateToProposal($id: ID!) {
    convertEstimateToProposal(id: $id) {
      publicId
    }
  }
`);

const useConvertEstimateToProposal = (args: {
  projectId: string;
  options?: UseMutationOptions<
    ConvertEstimateToProposalMutationResult,
    Error,
    { id: string }
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation({
    mutationFn: (variables: { id: string }) => {
      return gqlClient.request(ConvertEstimateToProposalMutation, variables);
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.project(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useConvertEstimateToProposal;
